import { faMailForward } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { useState } from 'react';
import myPic from '../../assets/images/myLogo.png';
import { useSignInWithEmailAndPassword } from 'react-firebase-hooks/auth';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { auth } from '../../firebase.init';
import Loading from '../Shared/Loading';
import { useRef } from 'react';

const Login = () => {
    const [signInWithEmailAndPassword, user, loading, error,] = useSignInWithEmailAndPassword(auth);
    const [isShahariar, setIsShahariar] = useState(false);

    const form = useRef();

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    useEffect(() => {
        if (user) {
            navigate(from, { replace: true });
        };
        if (error) {
            setIsShahariar(false)
        }
    }, [error, user, from, navigate]);

    if (loading) {
        return <Loading />;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const email = form.current.email.value;
        const password = form.current.password.value;
        await signInWithEmailAndPassword(email, password);
    }

    return (
        <div className="hero min-h-screen bg-[#02162b] items-start text-white">
            <div className="hero-content flex-col md:w-96">
                <div className="text-center lg:text-left">
                    <h2 className='text-green-600 text-center text-2xl p-5 Black-Ops-One'>Login form For Me!</h2>
                </div>
                {error && <h1 className="text-lg p-2 rounded text-center leading-6 font-Cormorant-Garamond font-bold text-red-700 bg-[#ffffb6] mb-5"> Sorry! You can't see my Messages But you can't send me one ......</h1>}
                <form
                    ref={form} onSubmit={handleSubmit}
                    className="flex-shrink-0 w-full shadow-[#000000b0] shadow-2xl bg-[#ffffff2f] rounded-2xl border-[1px] border-gray-800">
                    <div className="p-5">
                        {isShahariar ?
                            <>
                                <div className="avatar flex justify-center">
                                    <div className="w-10 rounded-full ring ring-[#02162b] ring-offset-white ring-offset-2">
                                        <img src={myPic} alt="" />
                                    </div>
                                </div>
                                <div className="form-control">
                                    <label className="label p-1"><span className="label-text text-white">Email</span></label>
                                    <input type="email" placeholder="My Email" name='email' className="rounded focus:text-green-500 focus:outline-none focus:font-play bg-[#00000070] text-sm h-9 input input-xs w-full" />
                                </div>
                                <div className="form-control">
                                    <label className="label p-1"><span className="label-text text-white">Password</span></label>
                                    <input type="password" placeholder="My Password" name='password' className="rounded focus:text-green-500 focus:outline-none focus:font-play bg-[#00000070] text-sm h-9 input input-xs w-full" />
                                </div>
                                <div className="form-control mt-6"> <input className="btn btn-sm capitalize h-9 font-play font-light rounded text-sm  text-green-400 hover:text-white bg-[#00283ac9] hover:bg-green-600 transition duration-150 ease-in-out border-[1px] border-green-900 hover:border-green-600" type="submit" value="login" /></div>
                                <div className="form-control mt-6" onClick={() => setIsShahariar(!isShahariar)} >
                                    <button className="btn btn-sm capitalize h-9 font-play font-light rounded text-sm  text-red-400 hover:text-white bg-[#3a000042] hover:bg-red-600 transition duration-150 ease-in-out border-[1px] border-green-900 hover:border-red-600">
                                        I'm not Md. Shahariar Rahman
                                    </button>
                                </div>
                            </>
                            :
                            <div className="form-control mt-6" onClick={() => setIsShahariar(!isShahariar)}>
                                <button className="btn btn-sm capitalize h-9 font-play font-light rounded text-sm  text-green-400 hover:text-white bg-[#00283ac9] hover:bg-green-600 transition duration-150 ease-in-out border-[1px] border-green-900 hover:border-green-600">
                                    I'm Md. Shahariar Rahman <img className='ml-3 w-7  grayscale' src={myPic} alt="" />
                                </button>
                            </div>}
                        <div className="form-control mt-6">
                            <a className="btn btn-sm capitalize h-9 font-play font-light rounded text-sm  text-green-400 hover:text-white bg-[#00283ac9] hover:bg-green-600 transition duration-150 ease-in-out border-[1px] border-green-900 hover:border-green-600" target="blank" href="https://mail.google.com/mail/?view=cm&fs=1&to=shahariarrahman98@gmail.com">
                                Send a Email <FontAwesomeIcon className='ml-2' icon={faMailForward} />
                            </a>
                        </div>
                        <div className="form-control mt-6">
                            <Link to="/contact" className="btn btn-sm capitalize h-9 font-play font-light rounded text-sm  text-green-400 hover:text-white bg-[#00283ac9] hover:bg-green-600 transition duration-150 ease-in-out border-[1px] border-green-900 hover:border-green-600">
                                Send a Massage <FontAwesomeIcon className='ml-2' icon={faMailForward} />
                            </Link>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Login;